/** @jsxImportSource @emotion/react */
import { Button, NoticeBar } from "@atomic/ui-kit"
import { useMutation } from "@apollo/client/react"
import { Eye, X } from "lucide-react"
import { type FC } from "react"
import { StopViewAsDocument } from "../../services/__generated__/graphql"
import { clearViewAs, getViewAs } from "../../services/impersonation"

/** The standing line while a View As session is active — the kit's notice bar
 *  in the warning tone. Exiting stops the session (audited) and reloads back
 *  into the operator's own view. */
export const ViewAsBanner: FC = () => {
  const viewAs = getViewAs()
  const [stopViewAs] = useMutation(StopViewAsDocument)

  if (!viewAs) return null

  const handleExit = async () => {
    try {
      await stopViewAs({ variables: { token: viewAs.token } })
    } catch {
      // Exiting must never be blocked by a failed stop call.
    }
    clearViewAs()
    window.location.reload()
  }

  return (
    <NoticeBar
      tone="warning"
      icon={<Eye size={14} aria-hidden />}
      action={
        <Button type="button" variant="tertiaryOutline" size="xs" onClick={() => void handleExit()}>
          <X size={13} aria-hidden />
          Exit
        </Button>
      }
    >
      Viewing as <strong>{viewAs.targetEmail || "user"}</strong>
    </NoticeBar>
  )
}
